module.exports = __webpack_public_path__ + "img/back.2ffd6ebb.svg";